import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  {
    name: 'Malabrigo',
    Peso_Proyectado: 7500,
    Peso_Real: 7500,
    amt: 2400,
  },
  {
    name: 'Chimbote',
    Peso_Proyectado: 6100,
    Peso_Real: 7050 ,
    amt: 2210,
  },
  {
    name: 'Vegueta',
    Peso_Proyectado: 5300,
    Peso_Real: 5300,
    amt: 2290,
  },
  {
    name: 'Callao',
    Peso_Proyectado: 7000,
    Peso_Real:7800 ,
    amt: 2000,
  },
];

//Redondeo a la barra
const RoundedRectangle = (props) => {
  const { x, y, width, height, fill } = props;
  return (
    <path
      d={`
        M${x},${y + 25} 
        Q${x},${y} ${x + 25},${y} 
        H${x + width - 25} 
        Q${x + width},${y} ${x + width},${y + 25} 
        V${y + height} 
        H${x} 
        V${y + 25}
        Z
      `}
      fill={fill}
    />
  );
};

export default class BarChartComponent extends PureComponent {
  render() {
    return (
      <div>
         <div className="flex items-center">
            <p className="text-[20px] font-itcmedium text-[#007696] ">Comparativo de Peso</p>
            <button className="sm:px-[35px] px-[35px] ml-[20rem] 2xl:ml-[53rem] h-[46px] text-[14px] text-center bg-white border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
            Filtrar por tiempo
            </button> 
        </div>

        <div className="flex justify-center items-center p-4  ">
          <div className="w-full max-w-7xl ">
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                data={data}
                width={500}
                height={300}
                margin={{
                  top: 10,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <defs>
                  {/* Degradado */}
                  <linearGradient id="gradientProyectado" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#77A042" />
                    <stop offset="100%" stopColor="#2C4013" />
                  </linearGradient>

                  <linearGradient id="gradientProyectado2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#5CBDEB" />
                    <stop offset="100%" stopColor="#266887" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="4 1 2" />
                <XAxis dataKey="name" />
                <YAxis 
                  tickFormatter={(value) => `${value} Kg`} 
                />
                <Tooltip />
                <Legend 
                  iconType="circle" 
                  iconSize={7}
                  align="start"
                  formatter={(value) => <span style={{ marginRight: '10px' }}>{value}</span>}
                />
                <Bar
                  dataKey="Peso_Proyectado"
                  fill="url(#gradientProyectado)"
                  shape={<RoundedRectangle />}
                  barSize={50}
                />
                <Bar
                  dataKey="Peso_Real"
                  fill="url(#gradientProyectado2)"
                  shape={<RoundedRectangle />}
                  barSize={50}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    );
  }
}
